import { useCallback } from 'react';
import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { Formik } from 'formik';
import { useFormCommonNumber } from '../hooks/useFormCommonNumber';
import PropTypes from 'prop-types';

const DefaultFormCCommonNumber = (props) => {
	const { isPlain, onSubmit, onCancel, serverError, fullHeight, ...rest } = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormCommonNumber();

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Новый общий номер"
						fullHeight={fullHeight}
						error={serverError}
						onCancel={onCancel}
						onSubmit={formikProps.handleSubmit}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCCommonNumber.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
};

export default DefaultFormCCommonNumber;
